import { RootState } from '../../../rootReducer';
import { IConnectorConfigState } from './types';

export const selectConfigState = (state: RootState): IConnectorConfigState => {
  return state.dashboard.connectorConfig;
};
